export const categories = {
  // animations: 'Animations',
  Animations: 'Animations',
  // movies: 'Movies',
  Movies: 'Movies',
  // musics: 'Musics',
  Musics: 'Musics',
  Original_Language_Movies: 'Original Language Movies',
  Series_irani: 'Series irani',
  Series_Khareji: 'Series Khareji',
  Series_Korea: 'Series Korea',
  Series_Turkey: 'Series Turkey',
  trailers: 'Trailers',
  Trailers: 'Trailers',
};

export const qualities = {
  '4320p': '8K 4320p Full Ultra HD',
  '2160p': '4K 2160p Ultra HD',
  '1440p': '2K 1080p QHD',
  '1080p': '1080p Full HD Blu-ray',
  '1080b': '1080p',
  '1080w': '1080p Full HD WebRip',
  '1080s': '1080p SD Cam',
  '720p': '720p HD',
  '480p': '480p SD',
};

export const formats = {
  mp4: 'MP4',
  avi: 'AVI',
  mkv: 'MKV',
  bluray: 'Blu-ray',
  mov: 'MOV',
  wmv: 'WMV',
  flv: 'FLV',
  avchd: 'AVCHD',
  webm: 'WEBM',
};

export const encoders = {
  mdbmax: 'Video and Sound MdbMax',
  other: 'Sound Another Site',
};
